import { StyleSheet } from 'aphrodite';
import { white, lightGray, charmGray, darkGrayFontColor, antiFlashWhite } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 20,
		maxWidth: 1200,
		margin: '0 auto',
	},

	headerContainer: {
		marginBottom: 30,
		paddingBottom: 20,
		borderBottom: `2px solid ${lightGray}`,
	},

	mainTitle: {
		fontSize: 24,
		fontWeight: 'bold',
		color: darkGrayFontColor,
		margin: 0,
		marginBottom: 8,
	},

	subtitle: {
		fontSize: 14,
		color: charmGray,
		margin: 0,
	},

	loadingContainer: {
		position: 'relative',
		minHeight: 400,
	},

	errorContainer: {
		padding: 40,
		textAlign: 'center',
		color: charmGray,
	},

	contentContainer: {
		marginTop: 20,
	},

	infoSection: {
		backgroundColor: white,
		border: `1px solid ${lightGray}`,
		borderRadius: 8,
		padding: 20,
		marginBottom: 20,
	},

	sectionTitle: {
		fontSize: 18,
		fontWeight: 'bold',
		color: darkGrayFontColor,
		marginBottom: 16,
		paddingBottom: 8,
		borderBottom: `2px solid ${lightGray}`,
	},

	sectionContent: {
		// Base styles for section content
	},

	infoRow: {
		display: 'flex',
		alignItems: 'flex-start',
		marginBottom: 12,
		':last-child': {
			marginBottom: 0,
		},
	},

	infoLabel: {
		fontWeight: 'bold',
		minWidth: 180,
		color: darkGrayFontColor,
		paddingRight: 12,
		flexShrink: 0,
	},

	infoValue: {
		color: charmGray,
		flexGrow: 1,
		wordWrap: 'break-word',
	},

	emailPreviewContainer: {
		border: `1px solid ${lightGray}`,
		borderRadius: 4,
		overflow: 'hidden',
		backgroundColor: white,
	},

	emailPreviewIframe: {
		width: '100%',
		minHeight: 400,
		border: 'none',
		backgroundColor: white,
	},

	emailPreviewContent: {
		width: '100%',
		minHeight: 400,
		padding: 20,
		backgroundColor: white,
		border: `1px solid ${lightGray}`,
		borderRadius: 4,
		overflow: 'auto',
		fontFamily: "'Open Sans', sans-serif",
	},

	previewPlaceholder: {
		padding: 40,
		textAlign: 'center',
		color: charmGray,
		backgroundColor: antiFlashWhite,
		border: `1px solid ${lightGray}`,
		borderRadius: 4,
	},

	errorMessage: {
		padding: 20,
		textAlign: 'center',
		color: '#d73a49',
		backgroundColor: '#ffeef0',
		border: '1px solid #fdbdbd',
		borderRadius: 4,
		fontWeight: 500,
	},

	approvalItem: {
		padding: 12,
		backgroundColor: antiFlashWhite,
		borderRadius: 4,
		marginBottom: 12,
		':last-child': {
			marginBottom: 0,
		},
	},

	attachmentsList: {
		// Container for attachments list
	},

	attachmentItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 12px',
		backgroundColor: antiFlashWhite,
		borderRadius: 4,
		marginBottom: 8,
		':last-child': {
			marginBottom: 0,
		},
	},

	attachmentName: {
		fontWeight: 'bold',
		color: darkGrayFontColor,
	},

	attachmentSize: {
		fontSize: 12,
		color: charmGray,
		marginLeft: 8,
	},

	sampleContactsContainer: {
		display: 'block',
		width: '100%',
	},

	sampleContactsList: {
		marginTop: 8,
		padding: 12,
		backgroundColor: antiFlashWhite,
		borderRadius: 4,
		maxHeight: 120,
		overflowY: 'auto',
	},

	sampleContact: {
		padding: '4px 0',
		fontSize: 14,
		color: charmGray,
		borderBottom: `1px solid ${lightGray}`,
		':last-child': {
			borderBottom: 'none',
		},
	},

	filterContainer: {
		display: 'block',
		width: '100%',
	},

	filterJson: {
		marginTop: 8,
		padding: 12,
		backgroundColor: antiFlashWhite,
		borderRadius: 4,
		fontSize: 12,
		color: charmGray,
		whiteSpace: 'pre-wrap',
		maxHeight: 200,
		overflowY: 'auto',
		fontFamily: 'monospace',
	},

	filterRenderer: {
		marginTop: 8,
		padding: 12,
		backgroundColor: antiFlashWhite,
		borderRadius: 4,
		fontSize: 14,
		maxHeight: 400,
		overflowY: 'auto',
	},

	filterGroup: {
		margin: '4px 0',
	},

	filterGroupOperator: {
		fontWeight: 'bold',
		color: darkGrayFontColor,
		fontSize: 13,
		marginBottom: 2,
	},

	filterGroupContent: {
		borderLeft: `2px solid ${lightGray}`,
		paddingLeft: 12,
		marginLeft: 8,
	},

	filterCriteria: {
		padding: '4px 0',
		lineHeight: '1.4',
	},

	filterProperty: {
		fontWeight: 'bold',
		color: darkGrayFontColor,
	},

	filterOperatorText: {
		color: charmGray,
		fontStyle: 'italic',
	},

	filterValue: {
		color: '#007acc',
		fontWeight: 500,
		backgroundColor: '#f0f8ff',
		padding: '1px 4px',
		borderRadius: 2,
	},

	filterOperator: {
		textAlign: 'center',
		fontWeight: 'bold',
		color: '#d73a49',
		backgroundColor: '#ffeef0',
		padding: '4px 8px',
		margin: '8px 0',
		borderRadius: 12,
		fontSize: 12,
		display: 'inline-block',
		minWidth: 40,
	},

	filterEmpty: {
		marginTop: 8,
		padding: 12,
		backgroundColor: '#fff3cd',
		borderRadius: 4,
		color: '#856404',
		fontStyle: 'italic',
		textAlign: 'center',
	},

	filterAccordion: {
		marginTop: 16,
		border: `1px solid ${lightGray}`,
		borderRadius: 4,
	},

	filterAccordionHeader: {
		width: '100%',
		padding: '8px 12px',
		backgroundColor: white,
		border: 'none',
		borderRadius: 4,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'pointer',
		fontSize: 13,
		color: charmGray,
		':hover': {
			backgroundColor: antiFlashWhite,
		},
	},

	filterAccordionIcon: {
		fontSize: 10,
		color: charmGray,
	},

	filterAccordionContent: {
		borderTop: `1px solid ${lightGray}`,
		padding: 0,
	},

	providerConfigRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		padding: '6px 0',
		borderBottom: `1px solid ${antiFlashWhite}`,
	},

	rateLimitsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},

	rateLimitItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '4px 8px',
		backgroundColor: '#f0f8ff',
		borderRadius: 4,
		fontSize: 13,
	},

	rateLimitCount: {
		fontWeight: 'bold',
		color: '#007acc',
		minWidth: 30,
	},

	rateLimitInterval: {
		color: charmGray,
	},
});
